import { render, staticRenderFns } from "./ProjectGrid.vue?vue&type=template&id=314f84ff&scoped=true"
import script from "./ProjectGrid.vue?vue&type=script&lang=ts"
export * from "./ProjectGrid.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314f84ff",
  null
  
)

export default component.exports